import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { PromotionTaskDto } from '@upme/contracts';
import { api } from '../../app/api-client';
import { promotionTasksKey } from './queries';

function invalidateList(qc: ReturnType<typeof useQueryClient>) {
  qc.invalidateQueries({ queryKey: [...promotionTasksKey, 'list'] });
}

export function useDonePromotionTask(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { resultNote?: string }) =>
      api.post(`admin/promotion-tasks/${id}/done`, { json: body }).json<PromotionTaskDto>(),
    onSuccess: () => invalidateList(qc),
  });
}

export function useCancelPromotionTask(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { resultNote: string }) =>
      api.post(`admin/promotion-tasks/${id}/cancel`, { json: body }).json<PromotionTaskDto>(),
    onSuccess: () => invalidateList(qc),
  });
}
